module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_vestfold_telemark_pos.4340c84d.svg";